import { GET_CATALOG_ERROR } from './actions';

// Flow-aware device loading for OrderDetails.
// - Return orders identify devices by their existing kit, so they need no
//   catalog (and orderability must not constrain them): zero requests.
// - Outbound orders load the strict per-org picker list in a single catalog
//   request. Device mappings are deliberately not consulted — they are
//   preference data for automatic ordering only.
export async function loadOrderableDevices({ isReturnFlow, targetOrgUuid, getCatalog }) {
  if (isReturnFlow || !targetOrgUuid) {
    return { skipped: true, devices: [] };
  }
  const resp = await getCatalog({ orgId: targetOrgUuid, orderable_only: true });
  if (resp?.type === GET_CATALOG_ERROR || !Array.isArray(resp?.response?.entries)) {
    return { error: resp, devices: null };
  }
  return { devices: resp.response.entries };
}
